import { z } from 'zod';
import apiClient from '@shared/api/http';
import type { CountryOption } from '../domain/datacenter';

// Puente autocontenido a GET /countries — no pertenece a @modules/catalog (plan.md §3/§7).
// v1 identifica el país de un datacenter por ISO-2, así que la opción se publica con ese código
// como `id`: es el valor que `datacenter.repository.ts` envía en `countryCode`.
const CountryOptionDtoSchema = z.object({
  id: z.union([z.string(), z.number()]),
  name: z.string(),
  code: z.string().nullish(),
  isoCode: z.string().nullish(),
});

function toDomain(dto: z.infer<typeof CountryOptionDtoSchema>): CountryOption {
  return {
    id: dto.code ?? dto.isoCode ?? String(dto.id),
    name: dto.name,
  };
}

export const countryOptionRepository = {
  async getAll(): Promise<CountryOption[]> {
    const { data } = await apiClient.get('/countries');
    return z.array(CountryOptionDtoSchema).parse(data).map(toDomain);
  },
};
